module.exports = __webpack_public_path__ + "img/eol-logo.2512a5f9.png";